<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :tables="pageData"
      :isExpansionPanelFooter="true"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="px-9 py-5">
            <v-col cols="5" v-if="isPossibleOperation">
              <InputFormNew
                v-model="localPageInfoData.line1"
                :detail="pageInfoDetail.line1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
                :isHideUnusedStorage="true"
              >
              </InputFormNew>
            </v-col>
          </v-row>
          <v-row no-gutters class="pa-0">
            <v-col
              cols="12"
              class="productTableCom"
              v-if="productInputData.length > 0"
            >
              <ProductTable
                :headers="pageData[0].productHeaders"
                :items="recItems.productMoves"
                :item-key="pageData[0].itemKey"
              >
                <template v-slot:done="{ item }">
                  {{ getProductInputData(item.productMoveId, 'done') }}
                </template>
                <template v-slot:notYet="{ item }">
                  <span class="red--text">
                    {{ getProductInputData(item.productMoveId, 'notYet') }}
                  </span>
                </template>
                <template v-slot:quantityAndStorageNo="{ item }">
                  <QuantityRackNumber
                    v-if="isPossibleOperation"
                    :rackNumberList="
                      productInputData[
                        getProductInputDataIndex(item.productMoveId)
                      ].rackNumberList
                    "
                    @change="
                      onChangeQuantityRackNumber(item.productMoveId, $event)
                    "
                    class="py-1"
                    :defaultQuantity="
                      productInputData[
                        getProductInputDataIndex(item.productMoveId)
                      ].notYet
                    "
                  />
                  <span v-else>-</span>
                </template>
                <template v-slot:productLotNumber="{ item }">
                  <v-text-field
                    class="px-2"
                    outlined
                    dense
                    hide-details
                    v-model="
                      productInputData[
                        getProductInputDataIndex(item.productMoveId)
                      ].productLotNumber
                    "
                    :disabled="!isPossibleOperation"
                  />
                </template>
                <template v-slot:productExpiredDate="{ item }">
                  <NormalDatePicker
                    class="px-2"
                    width="100%"
                    v-model="
                      productInputData[
                        getProductInputDataIndex(item.productMoveId)
                      ].productExpiredDate
                    "
                    :disabled="!isPossibleOperation"
                  />
                </template>
              </ProductTable>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template #expansionPanelFooter0>
        <v-container fluid>
          <v-row justify="end" class="ma-1">
            <div class="ma-2 btnStyle">
              <NormalButton
                :text="$t('loading.loading_loading')"
                textSize="16px"
                height="50px"
                width="100%"
                btnClass="ml-auto"
                :disabled="!isPossibleOperation"
                @click="register()"
              />
            </div>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[1].name]>
        <slot name="historyList" v-bind:item="historyListInfo" />
      </template>

      <template v-slot:[pageData[2].name]>
        <ClientInfo :recItems="recItems" />
      </template>
      <template v-slot:[pageData[3].name]>
        <OperationDetail :recItems="recItems" type="order" />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { commonUtil } from '@/util'

import MultipleAreaBase from './MultipleAreaBase'

import headersLoading from '@/views/order/Loading/headers'

import headersHistory from '@/views/order/History/headers'
import ClientInfo from '@/components/layouts/ClientConfirmation/SpplierInfo/SpplierInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'

import {
  NormalButton,
  InputFormNew,
  NormalDatePicker,
  ProductTable,
  QuantityRackNumber
} from '@/components/items'

export default {
  components: {
    MultipleAreaBase,
    InputFormNew,

    NormalDatePicker,
    QuantityRackNumber,
    // NormalNumberInput,

    NormalButton,
    ProductTable,
    ClientInfo,
    OperationDetail
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    pageInfoData: {}
  },
  data: () => ({
    localPageInfoData: {},
    pageData: [
      {
        title: 'loading.loading_loading',
        name: 'loadingInfo',
        productHeaders: [
          {
            text: 'common.product_product-number',
            value: 'product.productNumber',
            sortable: false,
            width: '108px',
            align: 'center'
          },
          {
            text: 'common.product_product-name',
            value: 'productName',
            sortable: false,
            width: '275px'
          },
          {
            text: 'common.product_capacity',
            value: 'product.capacity',
            sortable: false,
            width: '59px',
            align: 'center'
          },
          {
            text: 'common.input_order-quantity',
            value: 'quantity',
            sortable: false,
            width: '59px',
            align: 'center'
          },
          {
            text: 'loading.loading_already-loading',
            value: 'done',
            sortable: false,
            width: '56px',
            align: 'center'
          },
          {
            text: 'loading.loading_not-loading',
            value: 'notYet',
            sortable: false,
            width: '59px',
            align: 'center'
          },
          {
            text: 'loading.loading_loading-quantity-lot-number',
            value: 'quantityAndStorageNo',
            input: true,
            sortable: false,
            width: '232px',
            align: 'center'
          },
          {
            text: 'loading.loading_lot-number',
            value: 'productLotNumber',
            sortable: false,
            width: '124px',
            align: 'center'
          },
          {
            text: 'loading.loading_expiration-date',
            value: 'productExpiredDate',
            sortable: false,
            width: '143px',
            align: 'center'
          }
        ],
        itemKey: 'product.productNumber',
        items: null
      },
      {
        title: 'loading.loading_receipt-history',
        name: 'loadingHistory'
      },
      {
        title: 'order.order_supplier-info',
        name: 'spplierInfo'
      },
      {
        title: 'order.order_order-details',
        name: 'orderDetail'
      }
    ],

    isPossibleOperation: false,

    recDetail: {
      productListHeaders: headersHistory.productListHeaders
    },

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },

    // pageData 0
    pageInfoDetail: {
      line1: [
        {
          name: 'storageName',
          text: 'loading.loading_loading-storage',
          required: true,
          component: 'SelectStorageName',
          cols: 5
        },
        {
          name: 'loadingDate',
          text: 'loading.loading_loading-date',
          required: true,
          component: 'NormalDatePicker'
        },
        {
          name: 'remarks',
          text: 'common.input_remarks',
          textPositionStart: true,
          component: 'Remarks'
        }
      ]
    },
    productData: [],
    productInputData: [],
    allRackNumberList: [],
    test: 0,

    clientInfoData: [],
    historyListInfo: {
      historyList: [],
      headers: headersLoading.headers,
      tableKey: headersLoading.tableKey,
      productListHeaders: headersLoading.productListHeaders
    }
  }),

  created() {
    this.localPageInfoData = {
      line1: {
        storageName: { value: '', label: '' },
        loadingDate: commonUtil.getToday(),
        remarks: {
          data: '',
          title: '',
          text: ''
        }
      }
    }
  },
  methods: {
    ...mapActions('Loading', ['getLoadingListFromApi', 'registerLoading']),
    ...mapGetters('Loading', ['getLoadingListFromState']),
    ...mapActions('Sale', ['getRackNumberByProductFromApi']),
    ...mapGetters('Sale', ['getRackNumberByPaymentFromState']),
    ...mapActions('Common', ['setIsLoading']),
    getProductInputData(productMoveId, propertyName) {
      const rec =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return rec[propertyName]
    },

    async init() {
      await this.getLoadingList()
      this.setProductInputData()
    },

    async getLoadingList() {
      const loadingList = await this.getLoadingListFromApi({
        orderControlNumber: this.recItems.transaction.controlNumber,
        invalidLoadingDisplay: 0
      })
      const format = loadingList.data
        .sort((a, b) => {
          const keyName = 'loadingId'
          if (a[keyName] < b[keyName]) return 1
          if (a[keyName] > b[keyName]) return -1
          return 0
        })
        .map((ele, Index) => {
          ele.panelIndex = Index + 1
          return ele
        })
      this.historyListInfo.historyList = format
    },
    async getRackNumber() {
      const productListForRackNumber = await this.getProductListForRackNumber()
      const allRackNumberList = productListForRackNumber.map((ele) => {
        return {
          productId: ele.productId,
          rackInfoList: ele.rackInfoList
        }
      })
      return allRackNumberList
    },
    async setProductInputData() {
      const allRackNumberList = await this.getRackNumber(false)

      this.productInputData = this.recItems.productMoves.map((ele) => {
        const doneLengt = this.getDone(ele)
        const notYetLengt = ele.quantity - doneLengt

        return {
          productMoveId: ele.productMoveId,
          productId: ele.product.productId,
          productLotNumber: '',
          productExpiredDate: '',
          done: doneLengt,
          notYet: notYetLengt,
          rackInfoList: [{ quantity: notYetLengt }],
          rackNumberList: this.getRackNumberList(
            allRackNumberList,
            ele.product.productId
          )
        }
      })

      const ret = this.productInputData.filter((ele) => ele.notYet > 0)
      this.isPossibleOperation = ret.length > 0
    },

    getRackNumberList(allRackNumberList, productId) {
      // 対象商品が管理されている棚番号一覧
      const rackInfoList = allRackNumberList
        .filter((ele) => ele.rackInfoList.length > 0)
        .map((ele) => {
          ele.rackInfoList = ele.rackInfoList.filter((ele) => ele.rackNumber)
          return ele
        })
        .find((v) => {
          return v.productId === productId
        })
        ?.rackInfoList.map((rackInfo) => {
          return rackInfo.rackNumber
        })

      return rackInfoList ? rackInfoList : []
    },

    getProductInputDataIndex(productMoveId) {
      return this.productInputData.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },

    getDone(orderProductMoves) {
      const loadingList = this.getLoadingListFromState()
      return loadingList.reduce((result, loading) => {
        const targetList = loading.productMoves.filter(
          (ele) => ele.product.productId === orderProductMoves.product.productId
        )
        const targetAmount = targetList.reduce((result2, current2) => {
          return result2 + current2.quantity
        }, 0)
        return result + targetAmount
      }, 0)
    },

    // isNotYet(productMoveId) {
    //   return (
    //     this.productInputData[this.getProductInputDataIndex(productMoveId)]
    //       .notYet > 0
    //   )
    // },

    onChangeQuantityRackNumber(productMoveId, event) {
      const rackInfoList = event
      this.updateProductData(productMoveId, 'rackInfoList', rackInfoList)
    },
    updateProductData(productMoveId, updatePropertyNameName, updateData) {
      this.productInputData = this.productInputData.map((ele) => {
        if (ele.productMoveId === productMoveId) {
          ele[updatePropertyNameName] = updateData
        }
        return ele
      })
    },

    async register() {
      this.setIsLoading(true)
      const params = {
        orderId: this.recItems.orderId,
        pageInfoData: this.localPageInfoData.line1,
        productList: this.productInputData
      }
      const isConfirmed = confirm(this.$t('loading.loading_comfirm-to-store'))
      if (isConfirmed) {
        const isSucceed = await this.registerLoading(params)
        if (isSucceed) {
          alert(this.$t('common.common_saved-alert'))
          // this.inputedValue.dialog = false
          this.$emit('complete')
        }
      }
      this.setIsLoading(false)
    },
    async getProductListForRackNumber() {
      // 対象発注履歴に紐づく全商品の棚番号一覧を取得
      const productIdList = this.recItems.productMoves.map((ele) => {
        return ele.product.productId
      })

      if (this.localPageInfoData.line1.storageName.value) {
        await this.getRackNumberByProductFromApi({
          storageId: this.localPageInfoData.line1.storageName.value,
          productIdList: productIdList
        })
      }

      const productListForRackNumber = this.getRackNumberByPaymentFromState()
      return productListForRackNumber
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    'inputedValue.dialog': async function (val) {
      if (val) await this.init()
    },
    'localPageInfoData.line1.storageName': {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.value) {
          await this.init()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btnStyle {
  width: 130px;
}
.normalNumberInput {
  width: 180px;
}
</style>
